import { useEffect } from 'react';
import { ThemeMode } from '@freight-cbm/shared-types';

interface ThemeProviderProps {
  theme: ThemeMode;
}

export function ThemeProvider({ theme }: ThemeProviderProps) {
  useEffect(() => {
    const root = document.documentElement;

    const applyTheme = (isDark: boolean) => {
      root.setAttribute('data-theme', isDark ? 'dark' : 'light');
    };

    if (theme === ThemeMode.System) {
      const mq = window.matchMedia('(prefers-color-scheme: dark)');
      applyTheme(mq.matches);
      const handler = (e: MediaQueryListEvent) => applyTheme(e.matches);
      mq.addEventListener('change', handler);
      return () => mq.removeEventListener('change', handler);
    } else {
      applyTheme(theme === ThemeMode.Dark);
    }
  }, [theme]);

  return null; // no UI — just side effects
}
